module.exports = __webpack_public_path__ + "img/temperature-humidity-lg.374edd99.svg";